import { Directive, AfterViewInit, ElementRef, Injector } from '@angular/core';

import { DataBaseService } from './../../shared-feature/services/_base/data-base.service'; // Adjust the path as necessary
import { DocBaseService } from './../../shared-feature/services/_base/doc-base.service'; // Adjust the path as necessary

@Directive({
  selector: '[app-auto-focus]',
  exportAs: 'autoFocus',
  standalone: false
})
export class AutoFocusInputDirective implements AfterViewInit {
  private dataBaseService: DataBaseService | DocBaseService | null = null;

  constructor(
    private elementRef: ElementRef,
    private injector: Injector
  ) {
    try {
      this.dataBaseService = this.injector.get(DataBaseService);
    } catch (error) {
      //console.warn('DataBaseService not provided:', error);
      try {
        this.dataBaseService = this.injector.get(DocBaseService);
      } catch (error) {
        //console.warn('DataBaseService not provided:', error);
        this.dataBaseService = null; // Assign null if not available
      }
    }
  }

  ngAfterViewInit() {
    this.setFocusOnInit();
    this.subscribeToFocusObserver();
  }

  public focusManually() {
    this.setFocusOnInit();
  }

  // Method to set focus when the component loads
  private setFocusOnInit() {
    const elementRef = this.elementRef.nativeElement;
    if (elementRef && elementRef instanceof HTMLInputElement) {
      this.focus(elementRef);
    } else {
      const selectorRef = this.elementRef.nativeElement?.querySelector('input');
      if (selectorRef) {
        this.focus(selectorRef);
      }
    }
  }

  // Subscribe to the focusObserver from DataBaseService
  private subscribeToFocusObserver() {
    if (this.dataBaseService && this.dataBaseService.focusObserver) {
      this.dataBaseService.focusObserver.subscribe(() => {
        this.setFocusOnInit(); // Set focus again when focusObserver is triggered
      });
    }
  }

  // Focus helper method
  private focus(element: any) {
    setTimeout(() => {
      element.focus();
    }, 150); // Slight delay to ensure input is rendered
  }
}
